import React, { createContext, useCallback, useContext } from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { useLibraryTranslations } from '../../context/TranslationsContext';
import { useModalsAndWindow } from '../../context/ModalsAndWindowContext';
import { getInstallationFailedError } from '../../errors';
import { usePanorama } from '../../context/PanoramaContext';
import { reportErrorModalLoaded, reportInstallFailed } from '../../bi/bi';
import { useRenderControl } from '../../context/InstallerRenderControlContext';
export const ErrorHandlerContext = /*#__PURE__*/createContext({
  handleError: () => Promise.resolve()
});
export const ErrorHandlerProvider = _ref => {
  let {
    children,
    silentInstall,
    onInstallationFailed
  } = _ref;
  const {
    errorMonitor
  } = usePanorama();
  const {
    t
  } = useLibraryTranslations();
  const {
    setInstallerUiReady
  } = useRenderControl();
  const {
    newWindowHandlers,
    modals
  } = useModalsAndWindow();
  const handleError = useCallback(async errorObj => {
    var _errorMonitor, _errorObj$error;
    setInstallerUiReady();
    const error = getInstallationFailedError(errorObj);
    (_errorMonitor = errorMonitor()) == null || _errorMonitor.reportError(error, {
      context: errorObj
    });
    newWindowHandlers.closeWindow();
    if (!silentInstall) {
      reportErrorModalLoaded(JSON.stringify(errorObj.error), errorObj.messageKey, errorObj.requestId);
      await modals.error.open(errorObj);
    }
    reportInstallFailed(errorObj.requestId || ((_errorObj$error = errorObj.error) == null ? void 0 : _errorObj$error.requestId) || '');
    onInstallationFailed(error);
  }, [silentInstall, modals, onInstallationFailed, t]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    handleError: handleError
  }, /*#__PURE__*/React.createElement(ErrorHandlerContext.Provider, {
    value: {
      handleError
    }
  }, children));
};
export const useHandleError = () => useContext(ErrorHandlerContext);
//# sourceMappingURL=ErrorHandlerProvider.js.map